import React from "react";
import { InputText, PhoneNumberField, SelectField } from "../../components";
import { useFormContext } from "react-hook-form";
import { nikonUsaAddress } from "../../constant";

function StoreDetails() {
  const { control, setValue } = useFormContext();
  return (
    <>
      <div className="mb-8 space-y-3">
        <InputText
          label={"Store name"}
          control={control}
          required
          name={"store_info.name"}
          suggestions={nikonUsaAddress.map((item) => ({
            label: item.store_name,
            data: item,
          }))}
          helperText="Type the name of your store to search. If not found, enter your store name into the field."
          // helperText="Type the store name. If we find a match, the address will auto-fill"
          onsSuggestionSelect={(data) => {
            setValue("store_info.address", data?.data?.hq_street_address_1, {
              shouldValidate: true,
            });
            setValue("store_info.city", data?.data?.hq_city, {
              shouldValidate: true,
            });
            setValue("store_info.state", data?.data?.hq_state, {
              shouldValidate: true,
            });
            setValue("store_info.zip", data?.data?.hq_postal_code, {
              shouldValidate: true,
            });
          }}
        />
        <InputText
          label={"Store Address"}
          control={control}
          required
          name={"store_info.address"}
        />
        <InputText
          label={"Store City"}
          control={control}
          required
          name={"store_info.city"}
        />
        <div className="grid min-[540px]:grid-cols-2 grid-cols-1 gap-4">
          <InputText
            label={"Store State"}
            control={control}
            required
            name={"store_info.state"}
          />
          <InputText
            label={"Store Zip"}
            control={control}
            required
            name={"store_info.zip"}
          />
        </div>
        <PhoneNumberField
          control={control}
          name="store_info.phone"
          label="Store Phone"
        />
        <SelectField
          name="store_info.items_exchanged"
          label={"Were any items exchanged"}
          control={control}
          className="bg-transparent"
          options={[
            {
              label: "Yes",
              value: "Yes",
            },
            {
              label: "No",
              value: "No",
            },
          ]}
          defaultValue="No"
        />
      </div>
    </>
  );
}

export default StoreDetails;
